import { render, staticRenderFns } from "./common.vue?vue&type=template&id=0a080bff&scoped=true&"
import script from "./common.vue?vue&type=script&lang=js&"
export * from "./common.vue?vue&type=script&lang=js&"
import style0 from "./common.vue?vue&type=style&index=0&id=0a080bff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a080bff",
  null
  
)

export default component.exports